
var Misc = {
    updateValidation: function (formClass) {
        var currForm = $("." + formClass);
        currForm.removeData("validator");
        currForm.removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse(currForm);
        currForm.validate();
    }
};